<div class="wrap-top">
  <div class="icon" id="iconContainer" (click)="onClose()">
    <img class="iconssolidx" alt="" src="assets/icons/x-icon.svg" />
  </div>
</div>
<div class="repostaje-container">
  <h1>{{ "refueling" | translate }}</h1>
  <div class="form-group">
    <div class="label-container">
      <label>{{ "pick-the-fuel" | translate }}</label>
      <span class="required-tag">{{ "mandatory" | translate }}</span>
    </div>

    <div class="option-list">
      <div
        class="option-item"
        [class.selected]="selectedFuel === 'gasolina95'"
        (click)="selectFuel('gasolina95')"
        *ngIf="fuelTypeFromSummaryData == 1 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "petrol95" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'gasolina95'"
        ></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedFuel === 'gasolina98'"
        (click)="selectFuel('gasolina98')"
        *ngIf="fuelTypeFromSummaryData == 1 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "petrol98" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'gasolina98'"
        ></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedFuel === 'diesel'"
        (click)="selectFuel('diesel')"
        *ngIf="fuelTypeFromSummaryData == 3 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "diesel" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'diesel'"
        ></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedFuel === 'dieselPremium'"
        (click)="selectFuel('dieselPremium')"
        *ngIf="fuelTypeFromSummaryData == 3 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "premiun-diesel" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'dieselPremium'"
        ></div>
      </div>
    </div>
  </div>

  <div class="form-group">
    <div class="label-container">
      <label>{{ "pick-the-amount" | translate }}</label>
      <span class="required-tag">{{ "mandatory" | translate }}</span>
    </div>

    <div class="option-list">
      <div
        class="option-item"
        [class.selected]="selectedAmount === 10"
        (click)="selectAmount(10)"
      >
        <span>10€</span>
        <div class="radio-button" [class.active]="selectedAmount === 10"></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedAmount === 20"
        (click)="selectAmount(20)"
      >
        <span>20€</span>
        <div class="radio-button" [class.active]="selectedAmount === 20"></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedAmount === 50"
        (click)="selectAmount(50)"
      >
        <span>50€</span>
        <div class="radio-button" [class.active]="selectedAmount === 50"></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedAmount === 60"
        (click)="selectAmount(60)"
      >
        <span>60€</span>
        <div class="radio-button" [class.active]="selectedAmount === 60"></div>
      </div>
    </div>
  </div>

  <div class="info-box">
    <img src="assets/icons/shield-exclamation.svg" alt="" />
    <p>
      {{ "legal-text-refueling" | translate }}
    </p>
  </div>
</div>
<div class="modal-footer-extras">
  <button class="buttons-2" [disabled]="!isFormValid()" (click)="addTopping()">
    {{ "add" | translate }}
  </button>
</div>
